var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Huge-icon/interface/outline/filter"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 309",
    d: "M14.1141 1.5H3.88588C2.5815 1.5 1.80349 2.93666 2.52703 4.00923L6.8183 9.62058C7.176 10.1508 7.36687 10.7738 7.36687 11.4111V15.6914C7.36687 16.4103 8.24643 16.7704 8.76083 16.262L10.394 14.6481C10.5471 14.4967 10.6331 14.2915 10.6331 14.0774V11.4111C10.6331 10.7738 10.824 10.1508 11.1817 9.62058L15.473 4.00923C16.1965 2.93666 15.4185 1.5 14.1141 1.5Z",
    stroke: "#FCFCFC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.2d18d59285503a0d49aa0c129d5ae0b6.svg";
export { ForwardRef as ReactComponent };